<!-- 公告 -->
<template>
  <div class="notice-wrap" :class="{ 'electron-notice-wrap': isElectron }">
    <div class="swiper-container notice-container">
      <swiper
        :options="swiperOption"
        ref="noticeSwiper"
        class="swiper-container"
      >
        <swiper-slide v-for="item in noticeList" :key="item.id">
          <div
            :class="{ 'hover-active': item.href_type != 1 }"
            class="notice-title"
            @mouseenter="stopAutoplay"
            @mouseleave="startAutoplay"
            :data_href="item.href"
            :data_type="item.href_type"
            :data_id="item.id"
          >
            <img
              class="notice-icon"
              src="../../../assets/images/home/info-icon.png"
              alt=""
            />
            {{ item.title }}
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 占位 -->
    <div class="placeholder-ele"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { isMobile } from "@saas/components/src";
export default {
  props: {
    noticeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    let that = this;
    return {
      isMobile: isMobile(),
      isElectron: window.isElectron,
      swiperOption: {
        slidesPerView: "auto",
        speed: 1000,
        loop: true,
        grabCursor: true,
        preventClicks: false,
        preventClicksPropagation: false,
        direction: "vertical",
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，初始化swiper
        clickable: true,
        on: {
          click: function (e) {
            let type = Number(e.target.getAttribute("data_type") || "");
            let href = e.target.getAttribute("data_href") || "";
            let id = e.target.getAttribute("data_id") || "";
            let obj = {
              href,
              href_type: type,
              id,
            };
            that.jumpUrl(obj);
          },
        },
      },
    };
  },
  methods: {
    jumpUrl(item) {
      if (item.href_type === 2) {
        if (window.isElectron) {
          window.openUrlByExternal(item.href);
        } else {
          window.open(item.href);
        }
      } else if (item.href_type === 3) {
        let url = `/details/${item.id}`;
        if (window.isElectron || this.isMobile) {
          this.$router.push(url);
        } else {
          window.open(url);
        }
      } else {
        return false;
      }
    },
    stopAutoplay() {
      if (this.$refs.noticeSwiper?.swiper) {
        this.$refs.noticeSwiper.swiper.autoplay.stop();
      }
    },
    startAutoplay() {
      if (this.$refs.noticeSwiper?.swiper) {
        this.$refs.noticeSwiper.swiper.autoplay.start();
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="scss" scoped>
.electron-notice-wrap.notice-wrap {
  .notice-container {
    left: $side-bar-width;
  }
}
.notice-wrap {
  .notice-container {
    width: 100%;
    position: fixed;
    z-index: 9;
    background: linear-gradient(126deg, #edfff8 0%, #f9fffa 100%);
    padding: 10px;
    height: 40px;
    & > div {
      max-width: 1140px;
      height: 100%;
      font-size: 14px;
      color: $saas-text-color;
    }
    .notice-icon {
      width: 10px;
      margin-right: 6px;
    }
    .notice-title {
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: $saas-text-color;
      white-space: nowrap;
    }
    .hover-active {
      &:hover {
        text-decoration: underline;
      }
    }
    // 超出一行滚动轮播
    .swiper-slide.swiper-slide-active {
      width: 100%;
      animation: marquee-wrap 9s infinite linear;
      .notice-title {
        float: left;
        min-width: 100%;
        animation: marquee-content 9s infinite linear;
      }
    }
  }
  .placeholder-ele {
    height: 40px;
    width: 100%;
  }
}
// 适配
// @media (max-width: 767px) {
//   .notice-wrap {
//     margin-bottom: 0.4rem;
//     .notice-container {
//       padding: 0.21rem;
//       height: 1.01rem;
//       .notice-title {
//         font-size: 0.37rem;
//       }
//     }
//   }
// }

// 动画
@keyframes marquee-wrap {
  0%,
  30% {
    transform: translateX(0);
  }
  70%,
  100% {
    transform: translateX(100%);
  }
}

@keyframes marquee-content {
  0%,
  30% {
    transform: translateX(0);
  }
  70%,
  100% {
    transform: translateX(-100%);
  }
}
</style>
